import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { ConcessaoVeiculoSituacao } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-veiculo-situacao.enum';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { ConcessaoVeiculoDTO } from '../../../../../../model/dtos/mob/concessao-veiculo.dto';
import { ConcessaoVeiculoSearch } from '../../../../../../services/mob/concessao-veiculo.search';
import { ConcessaoVeiculoService } from '../../../../../../services/mob/concessao-veiculo.service';

@Component({
  selector: 'autocomplete-placa-coletivo-rural',
  templateUrl: './autocomplete-placa-coletivo-rural.component.html',
  styleUrls: ['./autocomplete-placa-coletivo-rural.component.scss'],
  viewProviders: [ParentFormGroup],
})
export class AutocompletePlacaColetivoRuralComponent implements OnInit {
  cdConcessaoVeiculo
  formGroup: FormGroup;
  concessaoVeiculos: ConcessaoVeiculoDTO[]
  filteredOptions: ConcessaoVeiculoDTO[]
  nrPlacaControl: FormControl;

  constructor(
    private _control: ControlContainer,
    private _concessaoVeiculoService: ConcessaoVeiculoService
  ) { }

  ngOnInit() {
    let filtro: ConcessaoVeiculoSearch = new ConcessaoVeiculoSearch({tpConcessao: ConcessaoTipo.COLETIVO_RURAL})
    this.nrPlacaControl = new FormControl('')
    this.formGroup = this._control.control as FormGroup;

    this.load(filtro)

    this.formGroup.get('cdConcessao').valueChanges.subscribe(async (value) => {
      
      this.load(new ConcessaoVeiculoSearch({cdConcessao:value, tpConcessao: ConcessaoTipo.COLETIVO_RURAL, stConcessaoVeiculo: ConcessaoVeiculoSituacao.VINCULADO})) 
    })


    this.nrPlacaControl.valueChanges.subscribe(value => {
      if (value != '') {
        this.filteredOptions = this._filter(value)
      } else {
        this.filteredOptions = this.concessaoVeiculos
      }
    });
  }

  private _filter(value: string): ConcessaoVeiculoDTO[] {
    const filterValue = value.toUpperCase();

    return this.concessaoVeiculos.filter(option => option.veiculo.nrPlaca.toString().toUpperCase().indexOf(filterValue) === 0);
  }

  mudaCdConcessaoVeiculo(valor) {
    if (this.formGroup.get('cdConcessaoVeiculo')) {
      this.formGroup.get("cdConcessaoVeiculo").setValue(valor ? valor.concessaoVeiculo.cdConcessaoVeiculo : null)
    }
    if (this.formGroup.get("cdVeiculo")) {
      this.formGroup.get("cdVeiculo").setValue(valor ? valor.veiculo.cdVeiculo : null)
    }
  }

  limparFormControl() {
    this.nrPlacaControl.setValue('')
  }

  async load(filtro: ConcessaoVeiculoSearch) {
    
    this.concessaoVeiculos = await this._concessaoVeiculoService.findVeiculos(filtro)
    if (this.formGroup.get('cdVeiculo') && this.formGroup.get('cdVeiculo').value) {
      this.concessaoVeiculos.map(value =>{
        if(value.cdVeiculo == this.formGroup.get('cdVeiculo').value){
          this.nrPlacaControl.setValue(value.veiculo.nrPlaca)
        }
      })
    }
    this.filteredOptions = this.concessaoVeiculos
  }
}
